var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileAlt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 -0.5 19 19",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 4.781V0H3.094c-.468 0-.844.376-.844.844v16.312c0 .468.376.844.844.844h11.812c.468 0 .844-.376.844-.844V5.625h-4.781c-.464 0-.844-.38-.844-.844zm2.25 8.297c0 .232-.19.422-.422.422H6.047c-.232 0-.422-.19-.422-.422v-.281c0-.232.19-.422.422-.422h5.906c.232 0 .422.19.422.422v.281zm0-2.25c0 .232-.19.422-.422.422H6.047c-.232 0-.422-.19-.422-.422v-.281c0-.232.19-.422.422-.422h5.906c.232 0 .422.19.422.422v.281zm0-2.531v.281c0 .232-.19.422-.422.422H6.047c-.232 0-.422-.19-.422-.422v-.281c0-.232.19-.422.422-.422h5.906c.232 0 .422.19.422.422zm3.375-4.011V4.5h-4.5V0h.214c.225 0 .44.088.598.246l3.442 3.445c.158.159.246.373.246.595z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileAlt);
export default __webpack_public_path__ + "static/media/file-alt.96e283f3acb633268662b74f37c8d874.svg";
export { ForwardRef as ReactComponent };